import React from 'react'

function Gallerie() {
    return (
        <div>
            <h1 className="font-extralight text-3xl">Downloads</h1>
        </div>
    )
}

export default Gallerie
